export default __webpack_public_path__ + "static/media/gallery-wip-3D-model_01.74d96cad.jpg";